import React from 'react';
import clsx from 'clsx';

type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

const tones: Record<StatusTone, string> = {
  neutral:
    'bg-secondary-100 text-secondary-700 dark:bg-secondary-800 dark:text-secondary-200',
  info: 'bg-primary-50 text-primary-700 dark:bg-primary-950 dark:text-primary-300',
  success:
    'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300',
  warning:
    'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300',
  danger: 'bg-danger-50 text-danger-700 dark:bg-danger-950 dark:text-danger-300',
};

const StatusBadge: React.FC<{
  children: React.ReactNode;
  tone?: StatusTone;
  className?: string;
}> = ({ children, tone = 'neutral', className }) => (
  <span
    className={clsx(
      'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold',
      tones[tone],
      className
    )}
  >
    {children}
  </span>
);

export default StatusBadge;
